import DataStoriesPage from 'components/pages/DataStoriesPage';

export const PortfolioDataStoriesPage = () => {
    return <DataStoriesPage showTreeTopHeader={false} project={null} contract={null} />;
};
